<!--申领-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container add-apply">
      <el-form v-loading="formLoading" :rules="rules" ref="addRef" :model="addObj" label-width="160px" size="mini">
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <p style="color: #428c63">{{ $t('please.check.your.bank.message') }}</p>
        <!-- 开户银行 -->
        <el-form-item v-show="!this.isAgent" :label="$t('miAgent.accountBank')+ ':'">{{ accountBank }}</el-form-item>
        <!-- 银行账户 -->
        <el-form-item v-show="!this.isAgent" :label="$t('fiaccount.num.bank')+ ':'">{{ accountCode }}</el-form-item>
        <!-- 账户类型 -->
        <el-form-item :label="$t('title.accout.type')+ ':'">{{ $t('fi.type.ac.e') }}</el-form-item>
        <!-- 申请额度 -->
        <el-form-item :label="$t('FiAcAppl.applicationAmount')+ ':'"><span style="color: #ff0021; font-size: large">{{ canUseF$ }}</span></el-form-item>
        <!-- 申领金额(美元) -->
        <el-form-item :label="$t('FiAcAppl.amount')+ '(' + $t('member.my') + ')' + ':'" prop="amount">
          <el-input style="width: 30%" v-model="addObj.amount" clearable @blur="amountBlur($event)" />
        </el-form-item>
        <!-- 支付币种 -->
        <el-form-item :label="$t('Common.paymentCurrency')+ ':'" prop="localCurrency">
          <el-select v-model="addObj.localCurrency" style="width: 30%" @change="localCurrencyChange">
            <el-option v-for="item in localCurrencyList" :key="item.currencyCode" :label="item.currencyCode" :value="item.currencyCode">
              <span>{{ item.currencyCode }} - </span>
              <span>{{ item.currencyName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 综合管理税费 -->
        <el-form-item v-show="!this.isAgent" :label="$t('fi.tax.multi')+ ':'">
          <el-input style="width: 30%" v-model="addObj.fees" :readonly="true" clearable />
        </el-form-item>
        <!-- 本位币 -->
        <el-form-item :label="$t('sys.sysCurrency')+ ':'">
          <el-input style="width: 30%" v-model="addObj.localMoney" :readonly="true" clearable />
        </el-form-item>
        <!-- 摘要 -->
        <el-form-item :label="$t('sys.notes')+ ':'">
          <el-input type="textarea" :rows="3" v-model="addObj.remark" style="width: 30%"/>
        </el-form-item>
        <!-- 请输入您的支付密码 -->
        <el-form-item :label="$t('please.input.your.pay.password')+ ':'" prop="payPassword">
          <el-input style="width: 30%" v-model="addObj.payPassword" show-password clearable />
        </el-form-item>
        <div style="text-align: center; margin-bottom: 10px">
          <el-button type="primary" :loading="saveLoading" @click="addSaveBtn">{{ $t('button.save') }}</el-button>
          <el-button icon="el-icon-close" @click="closeBtn">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {alCurrencyByUser} from "@/api/home"
import {mapGetters} from "vuex"
import {loadFiAcAppl, saveOrUpdateFiAcAppl} from "@/api/ay-account-manager"

export default {
  name: "AddApply",
  data() {
    return {
      formLoading: false,
      RATE: Number,
      percent: Number,
      accountBank: '',
      accountCode: '',
      canUseF$: '',
      localCurrencyList: [],
      saveLoading: false,
      addObj: {
        amount: '',
        localCurrency: '',
        fees: null,
        localMoney: '',
        remark: '',
        payPassword: ''
      },
      rules: {
        amount: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        localCurrency: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        payPassword: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}]
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'isAgent',
      'companyCode'
    ])
  },
  created() {
    this.getSum()
    this.getAlCurrency()
  },
  methods: {
    amountBlur(val) {
      if (val.target.value) {
        if (Number(val.target.value) <= Number(this.canUseF$)) {
          if (this.companyCode === 'BD') {
            this.addObj.fees = (Number(val.target.value) * Number(this.percent)).toFixed(2)
          } else {
            this.addObj.fees = (Number(val.target.value) * Number(this.percent)).toFixed(2)
          }
          const minus = Number(val.target.value) - Number(this.addObj.fees)
          this.addObj.localMoney = (minus * Number(this.RATE)).toFixed(2)
        } else {
          this.$message.error(this.$t('fiappl.amount.more.no'))
        }
      } else {
        this.$message.error(this.$t('fiappl.amount.no'))
      }
    },
    addSaveBtn() {
      if(this.addObj.amount<5 ){
        return this.$message.error(this.$t('Minimum.withdrawal')+'5$')
      }
      this.saveLoading = true
      this.$refs['addRef'].validate((valid) => {
        if (valid){
          this.addObj.rate = this.RATE
          saveOrUpdateFiAcAppl({...this.addObj}).then(() => {
            this.$router.back(-1)
            this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
            this.saveLoading = false
            this.resetForm('addRef')
          }).catch(err => {
            console.error(err)

            this.saveLoading = false
            this.$message.error(this.$t('bdSendRegister.operaterFail'))
          })
        } else {
          this.saveLoading = false
        }
      })
    },
    closeBtn() {
      this.$router.back(-1)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 支付币种change
    localCurrencyChange(val) {
      for (let a = 0; a < this.localCurrencyList.length; a++) {
        if (val === this.localCurrencyList[a].currencyCode) {
          this.RATE = this.localCurrencyList[a].rateToApple
          if (this.addObj.amount) {
            if (this.companyCode === 'BD') {
              this.addObj.fees = (Number(this.addObj.amount) * Number(this.percent) + 2).toFixed(2)
            } else {
              this.addObj.fees = (Number(this.addObj.amount) * Number(this.percent)).toFixed(2)
            }
            const minus = Number(this.addObj.amount) - Number(this.addObj.fees)
            this.addObj.localMoney = (minus * Number(this.RATE)).toFixed(2)
          }
        }
      }
    },
    // 获取支付币种
    getAlCurrency() {
      alCurrencyByUser().then(res => {
        this.localCurrencyList = res.data
        this.RATE = res.data[0].rateToApple
        this.addObj.localCurrency = res.data[0].currencyCode
      }).catch(err => {
        console.error(err)
      })
    },
    // 获取余额
    getSum() {
      this.formLoading = true
      loadFiAcAppl().then(res => {
        this.percent = res.data.percent
        this.canUseF$ = res.data.canUseF$
        this.accountBank = res.data.accountBank
        this.accountCode = res.data.accountCode
        this.formLoading = false
      }).catch(err => {
        this.formLoading = false
        console.error(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-apply {
  ::v-deep .el-form-item {
    margin: 7px;
  }
}
</style>
